export default "__VITE_ASSET__B9ArcDyD__"